/**
 * AppShell (06 §2) — two-pane desktop (≥1024px) / stacked mobile. Left pane =
 * ChatList (+ stacked overlays). Right pane = ConversationView or EmptyState.
 * On mobile, the URL decides whether the list or the conversation is on screen.
 * Hosts the global slide-over (info), media viewer, and toaster.
 */
import { useParams } from 'react-router-dom';
import { ChatList } from '../components/chat-list/ChatList';
import { ConversationView } from '../components/conversation/ConversationView';
import { EmptyState } from '../components/conversation/EmptyState';
import { InfoPanel } from '../components/info/InfoPanel';
import { MediaViewer } from '../components/media/MediaViewer';
import { Toaster } from '../components/primitives/Toaster';
import { useUiStore } from '../stores/uiStore';
import { useIsDesktop } from './useMediaQuery';
import { LeftOverlayHost } from './LeftOverlayHost';
import styles from './AppShell.module.css';

export function AppShell() {
  const { chatId } = useParams();
  const isDesktop = useIsDesktop();
  const leftOverlayOpen = useUiStore((s) => s.leftOverlay.kind !== 'none');

  if (isDesktop) {
    return (
      <div className={styles.shell}>
        <div className={styles.panes}>
          <aside className={styles.left}>
            <ChatList />
            {leftOverlayOpen && <LeftOverlayHost />}
          </aside>
          <main className={styles.right}>
            {chatId ? <ConversationView chatId={chatId} /> : <EmptyState />}
          </main>
        </div>
        <InfoPanel />
        <MediaViewer />
        <Toaster />
      </div>
    );
  }

  // Mobile: single-pane stack. Conversation route hides the list.
  return (
    <div className={styles.shell}>
      <div className={styles.stack}>
        {chatId ? (
          <ConversationView chatId={chatId} />
        ) : (
          <div className={styles.mobileLeft}>
            <ChatList />
            {leftOverlayOpen && <LeftOverlayHost />}
          </div>
        )}
      </div>
      <InfoPanel />
      <MediaViewer />
      <Toaster />
    </div>
  );
}
